import React from "react";
import { Card, CardContent, Box, Typography } from "@mui/material";

// Palette of soft gradient accents keyed by intent.
const GRADIENTS = {
  primary: "linear-gradient(135deg,#4f46e5,#7c3aed)",
  secondary: "linear-gradient(135deg,#db2777,#f472b6)",
  success: "linear-gradient(135deg,#059669,#34d399)",
  warning: "linear-gradient(135deg,#d97706,#fbbf24)",
  error: "linear-gradient(135deg,#dc2626,#f87171)",
  info: "linear-gradient(135deg,#0891b2,#22d3ee)",
  neutral: "linear-gradient(135deg,#475569,#94a3b8)",
};

// Compact KPI card: label, big value, optional icon badge and helper text.
// Optional onClick makes the whole card a navigation affordance (Analytics drill-down).
function StatCard({ label, value, icon, color = "primary", helper, onClick }) {
  const gradient = GRADIENTS[color] || GRADIENTS.primary;
  const clickable = typeof onClick === "function";
  return (
    <Card
      elevation={1}
      onClick={onClick}
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={
        clickable
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick();
              }
            }
          : undefined
      }
      sx={{
        position: "relative",
        overflow: "hidden",
        height: "100%",
        cursor: clickable ? "pointer" : "default",
        transition: "transform 0.15s ease, box-shadow 0.15s ease",
        "&:hover": { transform: "translateY(-2px)", boxShadow: 3 },
      }}
    >
      {/* Accent stripe */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          height: 4,
          background: gradient,
        }}
      />
      <CardContent sx={{ pt: 2.5 }}>
        <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
          <Box sx={{ minWidth: 0 }}>
            <Typography
              variant="overline"
              color="text.secondary"
              sx={{ display: "block", lineHeight: 1.6 }}
            >
              {label}
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 800, lineHeight: 1.1 }}>
              {value ?? 0}
            </Typography>
            {helper && (
              <Typography variant="caption" color="text.secondary">
                {helper}
              </Typography>
            )}
          </Box>
          {icon && (
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: 2.5,
                background: gradient,
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                boxShadow: "0 6px 16px rgba(15,23,42,0.15)",
              }}
            >
              {icon}
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
}

export default StatCard;
